export const INITIALISE_ACCORDION = 'BEAMLY/CCX/INITIALISE_ACCORDION';
export const TOGGLE_ACCORDION = 'BEAMLY/CCX/TOGGLE_ACCORDION';

export const initialise = (id, itemCount, isOpen) => ({
  type: INITIALISE_ACCORDION,
  id,
  itemCount,
  isOpen,
});

export const toggle = (id, index) => ({
  type: TOGGLE_ACCORDION,
  id,
  index,
});
